import { z } from 'zod';

export default z
  .number()
  .min(0, 'Enter a value between 1 and 100.')
  .max(100, 'Enter a value between 1 and 100.');
